<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/xuqiu/Lmanagement',title:'协同管理'},{title:'协同部门配置'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="承接部门">
                                <el-select v-model="q.jobGroup" :v="q.jobGroup"
                                           placeholder="请选择" :clearable="true"
                                           @change="okJobPoint">
                                    <el-option v-for="(item) in JobGroup"
                                               :key="item.id"
                                               :label="item.jobGroup"
                                               :value="item.jobGroup"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="答复人">
                                <el-input v-model="q.jobUsercode"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                                <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                                </el-button>
                                <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                                           @click="adduser">新增
                                </el-button>
                            </el-form-item>
                        </div>

                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table @selection-change="handleSelectionChange"
                              ref="multipleTable"
                              :data="tableData"
                              :border="true"
                              stripe
                              max-height="500"
                              style="width: 100%">
                        <el-table-column
                                type="selection"
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="jobGroup"
                                label="承接部门"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="jobUsername"
                                :show-overflow-tooltip="true"
                                label="答复人名称">
                        </el-table-column>
                        <el-table-column
                                prop="jobUsercode"
                                :show-overflow-tooltip="true"
                                label="答复人工号">
                        </el-table-column>
                        <el-table-column
                                prop="cuname"
                                :show-overflow-tooltip="true"
                                label="创建人名称">
                        </el-table-column>
                        <el-table-column
                                prop="cdate"
                                :show-overflow-tooltip="true"
                                width="180"
                                label="创建时间">
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="150">
                            <template slot-scope="scope">
                                <div class="w-caozuo" style="text-align: left;">
                                    <el-button
                                            type="text"
                                            size="small"
                                            class="h-tableLink h-btn" @click="handleEdit(scope.row)">
                                        修改
                                    </el-button>
                                    <el-button
                                            type="text"
                                            size="small"
                                            class="h-tableLink h-btn" @click="handleDelete(scope.row)">
                                        删除
                                    </el-button>
                                </div>

                                <!-- <div class="l-operationBox">
                                    <span class="l-operationlist br-operation-xg" title="修改" @click="handleEdit(scope.row)"></span>
                                    <span class="l-operationlist br-operation-delete" title="删除" @click="handleDelete(scope.row)"></span>
                                </div> -->
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="exportExcel">批量导出
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                       @click="uploaddownexcelflagbtn">批量导入
                            </el-button>
                            <uploaddownexcel
                                    :visible.sync="uploaddownexcelflag"
                                    v-if="uploaddownexcelflag"
                                    clsname="deptImportExcel"
                                    :startrow="2"
                                    :extparams="q"
                                    @callback="uploadExcelFilecallback"/>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="query"/>
                        </div>
                    </div>
                </div>
            </div>
            <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2 yonghu" @close="cancel('f')">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell" v-if="this.saveorupdate==1">
                            <h1>新增承接部门/答复人信息</h1>
                            <p>New</p>
                        </div>
                        <div class="h-tableCell" v-if="this.saveorupdate==2">
                            <h1>修改承接部门/答复人信息</h1>
                            <p>Update</p>
                        </div>
                    </div>
                </div>
                <div class="h-formLine h-mrb-38">
                    <el-form :model="f" :rules="rules" ref="f"
                             :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
                        <el-form-item label="承接部门" class="h-elformWrap-2" prop="jobGroup">
                            <el-input v-model.trim="f.jobGroup" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="答复人工号" class="h-elformWrap-2" prop="jobUsername">
                            <el-input @blur="getUserName()" v-model.trim="f.jobUsercode" placeholder="请输入"/>
                        </el-form-item>
                        <el-form-item label="答复人名称" class="h-elformWrap-2" prop="jobUsercode">
                            <el-input v-model.trim="f.jobUsername" placeholder="请输入"/>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button class="h-btn h-formBtn h-bgwhite" @click="cancel('f')">取消</el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ2" @click="insert">提交
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'

    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                //表格
                multipleSelection: [],
                canjobpoint:true,
                //导入Excel
                uploaddownexcelflag: false,
                //新增/修改弹窗
                saveorupdate: null,
                //临时的id
                iditem:'',
                userInfo: {
                    usercode: null,
                    username: null,
                },
                //分页/检索
                q: {
                    jobGroup:null,
                    jobUsercode:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                f:{
                    id:null,
                    jobGroup:null,
                    jobUsername: null,
                    jobUsercode:null
                },
                //链群
                JobGroup: [],
                JobPoint:[],
                //table列表
                tableData: [],
                //弹窗
                dialogFormVisible: false,
                rules:
                    {
                        jobGroup: [{required: true, message: '请输入承接部门', trigger: 'blur'}],
                        jobUsername: [{required: true, message: '请选择答复人名称', trigger: 'blur'}],
                        jobUsercode: [{required: true, message: '请输入答复人工号', trigger: 'blur'}],
                    }
            }
        },
        created() {
            this.query();
            this.selectJobGroup();
        },
        methods: {
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //节点筛选可用
            okJobPoint(){
                if(this.q.jobGroup!=null){
                    this.canjobpoint = false;
                    ss.xietongguanli.selectDeptPoint(this.q.jobGroup).then(rd => {
                        this.JobPoint = rd;
                    });
                }else{
                    this.canjobpoint = true;
                    this.q.jobPoint = null;
                }
            },
            //部门列表
            selectJobGroup() {
                ss.xietongguanli.selectDeptPoint().then(rd => {
                    this.JobGroup = rd;
                });
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
            //重置检索项
            resetData() {
                this.q.jobGroup = null;
                this.q.jobUsercode = null;
            },
            query() {
                ss.xietongguanli.deptUserPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            //新增
            adduser() {
                this.saveorupdate = 1
                this.f.id = null;
                this.f.jobGroup = null;
                this.f.jobUsername = null;
                this.f.jobUsercode = null;
                this.dialogFormVisible = true;
            },
            //弹框关闭
            cancel(formName) {
                this.dialogFormVisible = false;
                this.f.id = null;
                this.f.jobGroup = null;
                this.f.jobUsername = null;
                this.f.jobUsercode = null;
                this.$refs[formName].resetFields();
            },
            //新增
            insert() {
                var subflag = false;
                this.$refs['f'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });
                if (subflag == true) {
                    ss.xietongguanli.insertDept(this.f).then(rd => {
                        this.query();
                        this.$msg.msgs(rd.msg);
                        this.dialogFormVisible = false;
                    })
                }
            },
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //删除
            handleDelete(value) {
                this.$msg.confirm("确认删除?", () => {
                    ss.xietongguanli.deleteDept(value.id).then(rd => {
                        this.query();
                        this.$msg.msgs(rd.msg);
                    });
                });
            },
            //编辑
            handleEdit(value) {
                this.iditem = value.id;
                debugger
                this.saveorupdate = 2;
                ss.xietongguanli.selectDept(value.id).then(rd => {
                    this.dialogFormVisible = true;
                    this.f = rd;
                })
            },
            //根据用户编码获取用户信息
            getUserName(){
                var usercode = this.f.jobUsercode;
                ss.UserService.selectById(usercode).then(rd => {
                    console.log("getUserName",rd)
                    this.f={
                        id:this.iditem,
                        jobUsercode:rd.obj.usercode,
                        jobUsername:rd.obj.username,
                        jobGroup:this.f.jobGroup,
                    }
                    console.log("getUserName123",rd)
                })
            },
            //批量导出
            exportExcel() {
                var idlist = [];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.id);
                });
                updownfile.down("/api/swyl/v1/guanhuai/userResourceDemandJob/downloadExcel", idlist, "post", 'data');
            }
        }
    }
</script>

<style>
    .yonghu .h-formbLine .h-elformWrap-2 {
        width: 50%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__label {
        width: 41%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__content {
        width: 59%;
    }

    .yonghu .h-formbLine .el-form-item__content .el-select {
        width: 100% !important;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }
    .el-table tbody td:last-child{
        border-left: 1px solid #c2d2db;
    }
</style>
